import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Star } from 'lucide-react';
import { useAdminNav, flattenNav } from '../../design-system/adminNavCatalog';
import { useAdminNavPrefs } from './useAdminNavPrefs';

// Atalhos padrão (rotas reais); entram só se o perfil tiver acesso a elas.
const DEFAULTS = ['/v2/aluno', '/v2/matriculas', '/v2/academico/notas', '/v2/financeiro/dnapay/titulos', '/v2/central', '/v2/comunicacao/mensagens', '/v2/academico/turmas', '/v2/matriculas/documentos'];

export function AdminQuickAccess({ onSeeAll }) {
  const sections = useAdminNav();
  const { favs } = useAdminNavPrefs();
  const items = useMemo(() => {
    const flat = flattenNav(sections);
    const by = Object.fromEntries(flat.map((t) => [t.path, t]));
    const paths = [...new Set([...favs, ...DEFAULTS])].filter((p) => by[p]);
    return paths.slice(0, 6).map((p) => ({ ...by[p], fav: favs.includes(p) }));
  }, [sections, favs]);
  if (!items.length) return null;
  return (
    <section className="adm-m-quick" aria-labelledby="adm-m-quick-title" data-testid="adm-m-quick">
      <div className="adm-m-quick-head">
        <h2 id="adm-m-quick-title">Acesso rápido</h2>
        <button type="button" onClick={onSeeAll} data-testid="adm-m-quick-all">Ver todos <ChevronRight className="w-4 h-4" aria-hidden /></button>
      </div>
      <div className="adm-m-quick-grid">
        {items.map((t) => {
          const Ico = t.icon;
          return (
            <Link key={t.path} to={t.path} className={`adm-m-quick-item ${t.path === '/v2/aluno' ? 'hl' : ''}`} data-testid={`adm-m-quick-${t.path.replace(/\//g, '-')}`}>
              <Ico className="w-5 h-5" aria-hidden />
              <span>{t.label}</span>
              {t.fav && <Star className="adm-m-quick-star" aria-label="Favorito" />}
            </Link>
          );
        })}
      </div>
    </section>
  );
}
